import yup from 'modules/validation';

export const schema = yup.object().shape({});

export const model = {};

export const defaultValues = {};
